namespace('arctic.views.common');


arctic.views.common.testErrors = function(viewport, data) {
	this.run = function() {
		var testClickEvents = data.testClickEvents ? data.testClickEvents : false;
		/*testing javascript errors when they occur as part of drawing pages, not in response to clicks*/
		if(testClickEvents == 'click'){
			/*bind something to some event and then in the handler */
			$('body').bind('createError', function(e,data) {
    			var error = testingJSErrorsAsPartOfAnEvent;
    		});
    		/*immediately trigger an event that creates the error*/
    		$('body').trigger('createError', {});
		}
		else if(testClickEvents == 'ajax')
		{
			jQuery.ajax( {
	            url : '/testBackendErrors',
	            data: {'testWebServices': "doNotThrowError"},
	            dataType: 'json',
	            success: function(availData) {
	                var test = testingErrorsInAjaxSuccessHandlers;
	            }
	        } );
		}
		else{
			/* create an error as part of regular loadview*/
			var error = testingJSErrorsWhileRenderingPages;
		}
	};

};

